import { environment as env } from './environment';
import { Environment } from './environment.model';

export const environment: Environment = env;
